$(function() {

    var topBtn = $('#btn-totop');    
    var sidemenuBtn = $('#btn-side-menu');    
    topBtn.hide();
    sidemenuBtn.hide();
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            topBtn.fadeIn();
            sidemenuBtn.fadeIn();
        } else {
            topBtn.fadeOut();
            sidemenuBtn.fadeOut();
        }
    });
    //スクロールしてトップ
    topBtn.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });
});
